module.exports = __webpack_public_path__ + "static/media/excelIcon.c52363c0.svg";